/**
 * Short label for the « graine » ribbon.
 *
 * The seed the API carries is a full sentence written for the parent
 * (« La mer est salée parce que les rivières dissolvent… ») — it belongs in
 * the story page's text, not in a tag. On screen the ribbon must read in a
 * glance, so we keep the first clause and cap it: the tag is a hint, the
 * sentence is one tap away.
 *
 * The cap is what truncates, not CSS — worth remembering before reaching for
 * the stylesheet. At 42 it cut 58 of the 100 seeds in catalogue v1, i.e. very
 * nearly every story page showed an « … » (Fabien, 2026-09-22); at 90 it cuts
 * 14, and those are the genuinely long ones (the longest seed runs to 167
 * characters, which no tag should carry). 90 is also about what fits in the
 * two lines `.seed-tag` now allows on a story page.
 */
const MAX = 90;
const CLAUSE_BREAK = /\s[:;—–]\s|,\s|\s\(|\.\s/;

export function seedLabel(seed: string | null | undefined): string {
  if (!seed) return "";
  let s = seed.trim();
  const m = CLAUSE_BREAK.exec(s);
  if (m && m.index >= 12) s = s.slice(0, m.index);
  s = s.replace(/[.\s]+$/, "");
  if (s.length > MAX) {
    const cut = s.lastIndexOf(" ", MAX);
    s = s.slice(0, cut > 20 ? cut : MAX) + "…";
  }
  return s;
}
